export default __webpack_public_path__ + "static/media/holiday-inn-dark.72709f61.svg";